module.exports = __webpack_public_path__ + "static/media/queen-bed.e011ab35.png";